import { FieldHtmlNameUtil } from 'www-shared';
import UnifiedSignupScreenComponent from '../UnifiedSignupScreenComponent';
import AbstractSignupScreen from './AbstractSignupScreen';
import UnifiedSignupIntent from '../session-info/UnifiedSignupIntent';
import UnifiedSignupPersona from '../session-info/UnifiedSignupPersona';
import UnifiedSignupScreenName from '../UnifiedSignupScreenName';
import UnifiedSignupGradeLevel from '../session-info/UnifiedSignupGradeLevel';
import UnifiedSignupPersonaDetails from '../session-info/UnifiedSignupPersonaDetails';

export default class PersonaEduIntentSignupScreen extends AbstractSignupScreen {
  public readonly screenName: UnifiedSignupScreenName = 'uss-persona-edu-intent';

  // eslint-disable-next-line class-methods-use-this
  public getVisibleComponents(): UnifiedSignupScreenComponent[] {
    return [];
  }

  public getValidatedComponents(): UnifiedSignupScreenComponent[] {
    return [
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.whatIsYourExperience),
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.eduLevel),
      }),
    ];
  }

  /** Show this screen if we have checked email but don't know the users intent */
  public predicate(): boolean {
    return (this.isOkEmailOrEdu() || this.isOkEmailOrPro())
      && this.sessionInfo.value.intent !== null
      && this.sessionInfo.value.intent.compareTo(UnifiedSignupIntent.eduIntent)
      && this.sessionInfo.value.persona === null;
  }

  public async initListeners({
    partialDiv,
  }: {
    partialDiv: HTMLDivElement,
  }): Promise<void> {
    super.listenForFormInputs({
      partialDiv,
      fieldName: FieldHtmlNameUtil.whatIsYourExperience,
    });
    super.listenForFormInputsHover({
      partialDiv,
      fieldName: FieldHtmlNameUtil.whatIsYourExperience,
    });
    super.listenForFormInputs({
      partialDiv,
      fieldName: FieldHtmlNameUtil.eduLevel,
    });
  }

  public async toNextScreen(): Promise<boolean> {
    const persona = this.getField(FieldHtmlNameUtil.whatIsYourExperience).val;
    this.sessionInfo.value.persona = UnifiedSignupPersona.fromString(persona);
    const personaDetails = this.getField(FieldHtmlNameUtil.personaDetail).val;
    this.sessionInfo.value.personaDetails = UnifiedSignupPersonaDetails.fromString(personaDetails);
    const gradeLevel = this.getField(FieldHtmlNameUtil.eduLevel).val;
    this.sessionInfo.value.gradeLevel = UnifiedSignupGradeLevel.fromString(gradeLevel);
    return true;
  }

  // eslint-disable-next-line class-methods-use-this
  public getProgress(): number {
    return 30;
  }
}
